import { STATUS_COLORS } from "../../../constants"
import { getProjectQueryFromContext } from "../../../context-options/utils"
import { IOptionNormalized } from "../../../options/interfaces/options-normalized"
import { AppContextState } from "../../../types/app-context"
import { ProjectsDashboardQueryParams } from "../../api"

export const getProjectsDashboardQuery = (params: {
  appContext: AppContextState
  selectedCustomer: IOptionNormalized | null
  selectedMembership: IOptionNormalized | null
  selectedSupplier: IOptionNormalized | null
  selectedWorkspace: IOptionNormalized | null
}): ProjectsDashboardQueryParams => {
  const { appContext, selectedCustomer, selectedMembership, selectedSupplier, selectedWorkspace } = params
  const { mainContext, subContext } = appContext
  const context = subContext || mainContext

  let query: ProjectsDashboardQueryParams = {
    archived: "false",
    ...getProjectQueryFromContext(context),
  }

  const customerId = selectedCustomer?.id
  const membershipId = selectedMembership?.id
  const supplierId = selectedSupplier?.id
  const workspaceId = selectedWorkspace?.id

  if (customerId && !query.customer) query.customer = customerId
  if (membershipId && !query.member) query.member = membershipId
  if (supplierId && !query.supplier) query.supplier = supplierId
  if (workspaceId && !query.workspace) query.workspace = workspaceId

  return query
}

export const getStatusColorMap = (): { [key: string]: string } => {
  const colorVariations: { [key: string]: string } = {}
  for (let i = 0; i < 16; i++) {
    if (i < 4) {
      colorVariations[i] = STATUS_COLORS.IN_PROGRESS[i.toString() as "0" | "1" | "2" | "3"]
    } else if (i < 8) {
      colorVariations[i] = STATUS_COLORS.COMPLETED[(i - 4).toString() as "0" | "1" | "2" | "3"]
    } else if (i < 12) {
      colorVariations[i] = STATUS_COLORS.NOT_STARTED[(i - 8).toString() as "0" | "1" | "2" | "3"]
    } else {
      colorVariations[i] = STATUS_COLORS.REJECTED[(i - 12).toString() as "0" | "1" | "2" | "3"]
    }
  }
  return colorVariations
}
